// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3UTvA","disabled":"FileBtn_disabled__1Wwz0","warn":"FileBtn_warn__1MgkS","fade":"FileBtn_fade__9Gbfs"};